import { motion } from 'framer-motion';
import styled, { css } from 'styled-components';

export const PopoverWrapper = styled(motion.div)<{ $position?: 'top-left' | 'top-right' }>`
    position: absolute;
    z-index: 200;
    cursor: pointer;

    width: 292px;

    ${({ $position }) => {
        if ($position === 'top-left') {
            return css`
                top: 100%;
                left: 0;
            `;
        }

        if ($position === 'top-right') {
            return css`
                top: 100%;
                right: -5px;
            `;
        }
    }}

    margin-top: 17px;

    @media (min-width: ${(props) => props.theme.breakpoints.mobile}) {
        margin-top: 26px;
    }
`;

export const PopoverBox = styled(motion.div)`
    background: linear-gradient(116.56deg, #523df0 0%, #4b4092 101.94%);
    border-radius: 8px;
    padding: 20px;
    position: relative;
    z-index: 1;
    width: 100%;

    font-family: 'Alliance No.1';
    color: #ffffff;
`;

export const PopoverTitle = styled.div`
    font-weight: 700;
    font-size: 24px;
    line-height: 25px;
    letter-spacing: -0.02em;
    margin-bottom: 10px;
`;

export const PopoverText = styled.div`
    font-weight: 400;
    font-size: 16px;
    line-height: 19px;
    letter-spacing: -0.03em;
`;

export const PopoverArrow = styled.div<{ $position?: 'top-left' | 'top-right' }>`
    top: -5px;

    width: 11px;
    height: 11px;
    transform: rotate(45deg);
    position: absolute;

    ${({ $position }) => {
        if ($position === 'top-left') {
            return css`
                left: 16px;
                background: #523df0;

                @media (min-width: ${(props) => props.theme.breakpoints.mobile}) {
                    left: 24px;
                }
            `;
        }

        if ($position === 'top-right') {
            return css`
                right: 16px;
                background: #4d3fac;

                @media (min-width: ${(props) => props.theme.breakpoints.mobile}) {
                    right: 24px;
                }
            `;
        }
    }}
`;
